import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Podcast from "@/components/site/Podcast";
import Testimonials from "@/components/site/Testimonials";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="relative bg-black text-white grain min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Podcast />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
